import { render } from "./OrderForm.vue?vue&type=template&id=3757a226"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=3757a226&lang=scss"

import exportComponent from "F:\\my_work_space\\cmall-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__